import { useEffect, useState } from "react";
import { Star, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr, REVIEW_SERVICES } from "../lib/api";

// Blocco obbligatorio: dopo tre consultazioni serve una recensione per continuare.
// Il vincolo è lato server (403 review_required); questo modal raccoglie la recensione.
export const ReviewGate = () => {
  const [visible, setVisible] = useState(false);
  const [service, setService] = useState("sibille");
  const [rating, setRating] = useState(5);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const onRequired = () => {
      setSent(false);
      setVisible(true);
    };
    window.addEventListener("arcana-review-required", onRequired);
    return () => window.removeEventListener("arcana-review-required", onRequired);
  }, []);

  if (!visible) return null;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reviews", { service, text: text.trim(), rating });
      setSent(true);
      window.setTimeout(() => setVisible(false), 2400);
    } catch (e) {
      toast.error(fmtErr(e, "Recensione non inviata. Riprova."));
      if (e?.response?.status === 400) setVisible(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/75 backdrop-blur-sm px-4" data-testid="review-gate-modal">
      <div className="mystic-card max-w-sm w-full p-7 relative text-center" onClick={(e) => e.stopPropagation()}>
        {sent ? (
          <div className="py-6" data-testid="review-gate-sent">
            <Sparkles className="w-8 h-8 text-amber-400 mx-auto mb-4" />
            <p className="text-sm text-emerald-300 leading-relaxed">Grazie! Ora puoi continuare con le tue letture.</p>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl text-amber-100" data-testid="review-gate-title">Raccontaci com'è andata</h2>
            <p className="text-xs text-purple-300/70 mt-3 leading-relaxed" data-testid="review-gate-intro">
              Hai completato tre consultazioni. Per continuare con le letture, lascia una recensione
              sulla tua esperienza con Arcana.
            </p>
            <div className="flex items-center justify-center gap-2 mt-5" data-testid="review-gate-stars">
              {[1, 2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  type="button"
                  onClick={() => setRating(n)}
                  data-testid={`review-gate-star-${n}`}
                  aria-label={`${n} stelle`}
                  className="transition-transform hover:scale-110"
                >
                  <Star className={`w-8 h-8 ${n <= rating ? "text-amber-400 fill-amber-400" : "text-purple-300/30"}`} />
                </button>
              ))}
            </div>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              className="input-dark mt-4 text-left"
              data-testid="review-gate-service"
            >
              {REVIEW_SERVICES.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
            </select>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              rows={3}
              maxLength={1000}
              placeholder="La tua esperienza, con parole tue…"
              className="input-dark mt-3 text-left"
              data-testid="review-gate-text-input"
            />
            <div className="flex flex-col gap-3 mt-5">
              <button
                onClick={submit}
                disabled={busy || text.trim().length < 5}
                data-testid="review-gate-submit"
                className="gold-btn py-3 text-sm tracking-wide disabled:opacity-50"
              >
                {busy ? "Invio…" : "INVIA LA RECENSIONE"}
              </button>
              <button
                onClick={() => setVisible(false)}
                data-testid="review-gate-later"
                className="text-xs text-purple-300/60 hover:text-purple-200 transition-colors tracking-wide"
              >
                PIÙ TARDI
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
